"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Rozhraní pro práci s kontakty subjektu, který zatím není založen a je POUZE ověřen na základní registry - tedy máme jeho id ověření, viz {@link SubjektService#overSubjekt(Subjekt, String)}. Generated from cz.marbes.api.subjekt.KontaktOvereniService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T22:16:48Z                      #

// ##############################################################

var KontaktOvereniApi = function () {
  function KontaktOvereniApi() {
    (0, _classCallCheck3.default)(this, KontaktOvereniApi);
  }

  (0, _createClass3.default)(KontaktOvereniApi, null, [{
    key: "getSubjektKontakty",

    /**
     * Načtení všech kontaktů daného subjektu, případně pouze těch, které odpovídají předaným typům.
     *
     * @param overeniId id ověření subjektu
     * @param typyKontaktu seznam požadovaných typů, pokud je prázdný nebo null, vrací se všechny typy
     * @return seznam kontaktů nebo prázdný seznam
     */
    value: function getSubjektKontakty(overeniId, typyKontaktu) {
      var uri = serverContextPath + ("/api/subjekt/overeni/" + overeniId + "/kontakt");
      var headers = undefined;
      var params = { typyKontaktu: typyKontaktu };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }
  }]);
  return KontaktOvereniApi;
}();

exports.default = KontaktOvereniApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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